import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import config from '../../../application/config/config';
import Fetch from "../../../core/util/core/Fetch";

import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Col,
} from "reactstrap";
import classnames from "classnames";

import Form from "./Form.js"
import Payments from "./Tabs/Payments.js"

function Edit() {
  const [activeTab, setActiveTab] = useState('data');
  const [isLoading, setIsLoading] = useState(true)
  const [formValues, setFormValues] = useState(null)

  const { id } = useParams();

  const paths = {
    endpointGetById: config.endpoints.backend + 'gci/revenues/getById'
  }

  useEffect(() => {
    const load = async () => {
      const values = await Fetch.post(paths.endpointGetById, { id })
      setFormValues(values)
      setIsLoading(false)
    }
    load()
  }, [])

  return (
    <div>
      <Nav tabs>
        <NavItem>
          <NavLink
            style={{ cursor: "pointer" }}
            className={classnames({ active: activeTab === 'data' })}
            onClick={() => {
              setActiveTab('data');
            }}
          >
            Dados
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            style={{ cursor: "pointer" }}
            className={classnames({ active: activeTab === 'payments' })}
            onClick={() => {
              setActiveTab('payments');
            }}
          >
            Recebimentos
          </NavLink>
        </NavItem>
      </Nav>
      {
        isLoading ? <p> Carregando.. </p> : (
          <TabContent activeTab={activeTab} className="bg-white">
            <TabPane tabId={'data'}>
              <Col sm="12">
                <Form formValues={formValues} />
              </Col>
            </TabPane>
            <TabPane tabId={'payments'}>
              <Col sm="12">
                <Payments formValues={formValues} />
              </Col>
            </TabPane>
          </TabContent>
        )
      }
    </div>
  );
}
export default Edit;